module.exports = __webpack_public_path__ + "assets/img/returns.4931568b.svg";